import Swal from "sweetalert2";

const SweetAlert = ({ title, text, confirmAction, inputField = null, showSuccessAlert = true }) => {
    return Swal.fire({
      title: title,
      text: text,
      icon: "warning",
      input: inputField ? "text" : null,
      inputPlaceholder: inputField ? `Enter ${inputField}...` : "",
      inputValidator: (value) => {
        if (inputField && !value) {
          return `${inputField} is required!`;
        }
      },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, confirm!",
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const inputValue = Swal.getInput()?.value;
  
        if (inputField && !inputValue) {
          Swal.showValidationMessage(`${inputField} is required!`);
          return false;
        }
  
        try {
          const result = await confirmAction(inputValue); // your async function
          return result; // resolve on success
        } catch (error) {
          Swal.showValidationMessage(`Failed: ${error.message || "Unknown error"}`);
          throw error; // reject to prevent closing
        }
      }
    }).then((result) => {
      if (result.isConfirmed && result.value !== undefined && showSuccessAlert) {
        Swal.fire("Success!", "Action completed successfully.", "success");
      }
    }).catch(() => {
      // Catch unhandled promise rejection if any
      Swal.fire("Error!", "Something went wrong.", "error");
    });
  };
  

export default SweetAlert;
